import React from 'react'
import { store } from '../../store/index'
import Button from 'components/Button'

import noImage from 'assets/images/no-image.svg'
import accessClose from 'assets/images/access-close.svg'
import { CONFIG_BASE_URL } from '../../utils/consts'

export default class ControllersListItem extends React.Component {
  render() {
    const { controller, selectedControllers } = this.props
    const { access } = store.getState().tokenInfo

    return (
      <tr>
        <td className='table__checkbox'>
          <input
            type='checkbox'
            value={controller.id}
            checked={selectedControllers.has(controller.id)}
            onChange={this.props.toggleController}
          />
        </td>
        <td className='table__photo'>
          <div
            className='wrapper-photo'
            style={{
              backgroundImage: `url(${
                controller.preview
                  ? CONFIG_BASE_URL +
                    `${controller.preview}?token=${access}`
                  : noImage
              }`,
            }}></div>
        </td>
        <td
          className='table__name table__name--link border-right0'
          onClick={() => this.props.openModal(controller)}>
          {controller.title}
        </td>
        <td className='table__btn'>
          <Button className='btn--icon' icon={true} iconPicture={accessClose} />
        </td>
      </tr>
    )
  }
}
